import { isUndNullEmp } from '../../helpers/main.js';

export class PaymentInformationDetail {
    constructor(
        _id = 0,
        _name = '',
        _accountNumber = '',
        _accountType = '',
        _paymentInformationId = 0,
        _companyId = 0,
        _register = '',
    ) {
        this.id = _id;
        this.name = _name;
        this.accountNumber = _accountNumber;
        this.accountType = _accountType;
        this.paymentInformationId = _paymentInformationId;
        this.companyId = _companyId;
        this.register = _register;
    }

    static getClassName = () => {
        return 'PaymentInformationDetail - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 0,
                    Name: 2,
                    AccountNumber: 5,
                    AccountType: 4,
                    PaymentInformationId: 0,
                    CompanyId: 0,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    Name: 100,
                    AccountNumber: 50,
                    AccountType: 50,
                    PaymentInformationId: 450,
                    CompanyId: 450,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 0,
                    name: 2,
                    accountNumber: 5,
                    accountType: 4,
                    paymentInformationId: 0,
                    companyId: 0,
                    register: 10,
                },
                max: {
                    id: 450,
                    name: 100,
                    accountNumber: 50,
                    accountType: 50,
                    paymentInformationId: 450,
                    companyId: 450,
                    register: 30,
                },
            };
        }
    }

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: PaymentInformationDetail.getClassName() })?.result) {
            if (upperCase) {
                return new PaymentInformationDetail(
                    obj.Id,
                    obj.Name,
                    obj.AccountNumber,
                    obj.AccountType,
                    obj.PaymentInformationId,
                    obj.CompanyId,
                    obj.Register,
                );
            } else {
                return new PaymentInformationDetail(
                    obj.id,
                    obj.name,
                    obj.accountNumber,
                    obj.accountType,
                    obj.paymentInformationId,
                    obj.companyId,
                    obj.register,
                );
            }
        } else {
            return new PaymentInformationDetail();
        }
    }
}